"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

var _react = _interopRequireDefault(require("react"));

var _OurBrand = _interopRequireDefault(require("../components/OurBrand"));

var _SubBrand = _interopRequireDefault(require("../../../contexts/SubBrand"));

function _interopRequireDefault(obj) {
  return obj && obj.__esModule ? obj : {
    default: obj
  };
}

function OurBrand(_ref) {
  var goToNextWizardStage = _ref.goToNextWizardStage;
  return /*#__PURE__*/_react.default.createElement(_SubBrand.default.Consumer, null, function (_ref2) {
    var subBrand = _ref2.subBrand,
        updateSubBrand = _ref2.updateSubBrand;
    return /*#__PURE__*/_react.default.createElement(_OurBrand.default, {
      goToNextWizardStage: goToNextWizardStage,
      subBrand: subBrand,
      updateSubBrand: updateSubBrand
    });
  });
}

var _default = OurBrand;
exports.default = _default;